import http from "../utils/http";
import { toast } from "react-toastify";
import { store } from "../store";
import { setLoader, removeLoader } from "../redux/actions/loader";

export const save_bateria_virtual = async (payload) => {
  try {
    store.dispatch(setLoader("Guardando batería virtual"));
    const res = await http.post(`/erp/bateria-virtual`, payload);
    return res.data.bateria_virtual;
  } catch (err) {
    const mensaje =
      err?.response?.data?.error || "Error al guardar la batería virtual";
    toast.error(mensaje, {
      position: toast.POSITION.TOP_CENTER,
    });
  } finally {
    store.dispatch(removeLoader());
  }
};

export const get_bateria_virtual_data = async (params) => {
  try {
    const res = await http.get(`/erp/bateria-virtual`, { params });
    return res.data;
  } catch (err) {
    const mensaje =
      err?.response?.data?.error || "Error al obtener los cups destino";
    toast.error(mensaje, {
      position: toast.POSITION.TOP_CENTER,
    });
    return { cups_destino_options: [], bateria_virtual: null };
  }
};
